module.exports = __webpack_public_path__ + "img/sunscreen-fluid.448ea542.jpg";